import { Observable } from 'rxjs';

export type LogoutFn = () => Observable<unknown> | Promise<unknown>;

export class AuthorizationConfiguration {
  constructor(public logoutFn: LogoutFn) {}
}
